<section class="bg-(--color-main) pt-10 pb-20">
  <div class="cta-body text-center">
  <h3>هل تحتاج إلى استشارة متخصصة؟</h3>
  <p>فريقنا من الخبراء جاهز لمساعدتك في اختيار الخدمة المناسبة لاحتياجاتك</p>
  </div>

  <div class="flex justify-center mt-10 cursor-pointer">
        <button routerLink="/contact-us" class="bg-(--color-secondary) text-(--color-main) px-25 h-12 rounded-md font-semibold inline-flex items-center gap-2 cursor-pointer">
        تواصل معنا الأن
        </button>
      </div>
</section>
